import ChipButton from './ChipButton'

export * from './ChipButton'

export default ChipButton
